<script>
  import { Circle } from "svelte-loading-spinners";
  import Error from "../Common/Error.svelte";
  import subscribeToNewsletter from "../../helpers/subscribeToNewsletter";
  import Success from "../Common/Success.svelte";

  // State
  let email = "",
    subscribed = false,
    subscriptionLoading = false,
    subscriptionError = false;

  // Subscription Handler
  const handleSubscription = async (email) => {
    subscriptionLoading = true;
    const response = await subscribeToNewsletter(email);

    if (response.code && response.code != 200) {
      subscriptionError = true;
      setTimeout(() => {
        subscriptionError = false;
      }, 5000);
      console.error(response);
    } else {
      subscribed = true;
    }

    subscriptionLoading = false;
  };
</script>

<div id="reports-newsletter-signup-footer">
  <img
    id="reports-newsletter-signup-footer-img"
    src={`${WP.themeDir}/src/img/reports-newsletter-subscribe.png`}
    alt="Sign up for the newsletter"
  />

  <div class="inner">
    <h2>Get the latest DOAA reports straight to your inbox.</h2>
    {#if subscriptionError}
      <div class="message">
        <Error>There was an error processing your subscription.</Error>
      </div>
    {:else if subscribed}
      <div class="message">
        <Success>Thanks for signing up for our reports subscription.</Success>
        <p>
          You should receive an email to activate your account in a few minutes.
          If not, be sure to check your spam folder just in case. Once you
          activate your account you will be able to change your subscription
          preferences and/or unsubscribe at any time.
        </p>
      </div>
    {:else}
      <p>Sign up to receive regular updates, filtered to your preferences.</p>
      <form on:submit|preventDefault={() => handleSubscription(email)}>
        <input
          type="email"
          bind:value={email}
          placeholder="Email Address"
          disabled={subscriptionLoading}
        />
        <button
          type="submit"
          class="button"
          disabled={subscriptionLoading || !email.length}
        >
          {#if subscriptionLoading}
            <Circle size="20" color="#fff" unit="px" />
          {:else}
            Subscribe
          {/if}</button
        >
      </form>
    {/if}
  </div>
</div>

<style>
  #reports-newsletter-signup-footer {
    min-height: 413px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    padding-top: 7.31%; /* 124px @ full design width (1694) */
    padding-bottom: 6.61%; /* 112px @ full design width (1694) */
  }

  #reports-newsletter-signup-footer-img {
    position: absolute;
    background-color: #ffffff;
    opacity: 0.35;
    left: 0;
    top: 0;
    width: auto;
    height: 100%;
    width: 100%;
    z-index: -1;
    object-fit: cover;
  }

  #reports-newsletter-signup-footer h2 {
    font-family: "Georgia";
    font-weight: 400;
    font-style: normal;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #0e4369;
  }

  #reports-newsletter-signup-footer p {
    font-family: "Segoe UI", sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #2d2d2d;
  }

  form {
    margin-top: 38px;
  }

  #reports-newsletter-signup-footer input[type="email"] {
    width: 100%;
    max-width: 410px;
    min-height: 65px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;
    border: none;
    font-family: "Segoe UI", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    line-height: 24px;
    color: #4a4a4a;
  }

  button {
    min-width: 187px;
    min-height: 65px;
    margin-left: 48px;
  }

  .message {
    max-width: 680px;
    margin: 20px auto 0;
    padding: 20px;
    text-align: center;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
  }

  @media screen and (max-width: 840px) {
    form {
      width: 100%;
      max-width: 420px;
      margin: 40px auto;
      display: flex;
      flex-direction: column;
    }

    input {
      min-width: 100%;
    }
    button {
      min-width: 100%;
      margin-left: 0;
      margin-top: 40px;
    }
  }
</style>
